import React, { useState } from 'react';
import configEnv from 'env';
import classNames from 'classnames';
import { Input, Select, InputNumber } from 'antd';
import FieldRegister from 'views/common/FieldRegister';
import TextField from 'views/common/TextField';
import useEventCallback from 'hooks/useEventCallback';
import { validateRequired } from 'utils/validate';
import { CATEGORY, PROJECT_TYPE } from 'constants/constants';
import pngImage from 'assets/image-preview.png';

const validateRetryTimeAndTimeout = (value, values, key, depends) => {
  if ((value !== 0) && !value) return;
  const depend = depends[key];
  if (value > depend) return "Retry time must to less than equal timeout";
}

const GeneralInformation = ({
  stateInfo,
  onChange,
  onChangeFileAvatar,
  isPageApprove,
  permissionDisabled,
}) => {
  const [previewAvatar, setPreviewAvatar] = useState();

  const onChangeProjectType = useEventCallback(
    (v) => {
      onChange({ ...stateInfo, projectType: v });
    },
    [stateInfo]
  );

  const onChangeCategory = useEventCallback(
    (v) => {
      onChange({ ...stateInfo, category: v });
    },
    [stateInfo]
  );

  const onChangeNumberWorker = useEventCallback(
    (v) => {
      onChange({ ...stateInfo, numberWorker: v });
    },
    [stateInfo]
  );

  const onChangeAccessLevel = useEventCallback(
    (v) => {
      onChange({ ...stateInfo, accessLevel: v });
    },
    [stateInfo]
  );

  const onChanegFunctionName = useEventCallback(
    (e) => {
      onChange({ ...stateInfo, name: e.target.value });
    },
    [stateInfo]
  );

  const onChangeTimeout = useEventCallback(
    (v) => {
      onChange({ ...stateInfo, timeout: v });
    },
    [stateInfo]
  );

  const onChangeRetryTime = useEventCallback(
    (v) => {
      onChange({ ...stateInfo, retryTime: v });
    },
    [stateInfo]
  );

  const onChangeDesc = useEventCallback(
    (e) => {
      onChange({ ...stateInfo, description: e.target.value });
    },
    [stateInfo]
  );

  const onChangePreview = (file) => {
    onChangeFileAvatar(file.target.files[0]);
    setPreviewAvatar(URL.createObjectURL(file.target.files[0]));
  };

  return (
    <div className="input-project">
      <div className="input-project__block">
        <div
          className={classNames('upload-avatar', {
            'upload-avatar--active': previewAvatar,
          })}
        >
          <img
            src={
              previewAvatar ||
              (stateInfo.avatar &&
                `${configEnv.STORAGE_BASE_URL}/user/${stateInfo.avatar}`) ||
              pngImage
            }
            alt="projetc"
          />
          {!isPageApprove && !permissionDisabled && (
            <input accept="image/*" onChange={onChangePreview} type="file" />
          )}
        </div>
      </div>
      <div className="input-project__block">
        <FieldRegister
          name="name"
          onChange={onChanegFunctionName}
          value={stateInfo.name}
          disabled={isPageApprove || permissionDisabled}
          validate={validateRequired('Function name')}
        >
          {({ onBlur, onChange, value, error, disabled }) => (
            <TextField label="Function name" required helperText={error}>
              <Input
                placeholder="Enter function name"
                size="large"
                className="input-project__input"
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                disabled={disabled}
              />
            </TextField>
          )}
        </FieldRegister>
      </div>
      <div className="input-project__block">
        <FieldRegister
          name="projectType"
          value={stateInfo.projectType}
          onChange={onChangeProjectType}
          validate={validateRequired('Project type')}
          disabled={isPageApprove || permissionDisabled}
        >
          {({ onBlur, onChange, value, error, disabled }) => (
            <TextField
              label="Project type"
              required
              helperText={error}
              help={
                <span>
                  <p>One to One is ...</p>
                  <p>One to Many is ...</p>
                </span>
              }
            >
              <Select
                placeholder="Select project type"
                style={{ width: '100%' }}
                size="large"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
              >
                <Select.Option value={PROJECT_TYPE.FASTEST}>
                  Fastest
                </Select.Option>
                <Select.Option value={PROJECT_TYPE.ONE_TO_ONE}>
                  One to One
                </Select.Option>
                <Select.Option value={PROJECT_TYPE.ONE_TO_MANY}>
                  One to Many
                </Select.Option>
              </Select>
            </TextField>
          )}
        </FieldRegister>
        {stateInfo.projectType === PROJECT_TYPE.FASTEST && (
          <FieldRegister
            name="numberWorker"
            value={stateInfo.numberWorker}
            onChange={onChangeNumberWorker}
            validate={validateRequired('Number worker')}
            disabled={isPageApprove || permissionDisabled}
          >
            {({ onBlur, onChange, value, error, disabled }) => (
              <TextField
                label="Number worker"
                required
                helperText={error}
                help={
                  <span>
                    When project type is fastest, Number worker is the number of
                    workers that will do the work and then get the the result of
                    the the fastest worker.
                  </span>
                }
              >
                <InputNumber
                  min={2}
                  max={10}
                  className="input-project__timeout"
                  type="number"
                  size="large"
                  placeholder="Enter number worker"
                  onChange={onChange}
                  value={value}
                  disabled={disabled}
                  onBlur={onBlur}
                />
              </TextField>
            )}
          </FieldRegister>
        )}
        <FieldRegister
          name="category"
          value={stateInfo.category}
          onChange={onChangeCategory}
          validate={validateRequired('Category')}
          disabled={isPageApprove || permissionDisabled}
        >
          {({ onBlur, onChange, value, error, disabled }) => (
            <TextField label="Category" required helperText={error}>
              <Select
                placeholder="Select category"
                style={{ width: '100%' }}
                size="large"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
              >
                {Object.keys(CATEGORY).map((key) => (
                  <Select.Option key={key} value={key}>
                    {CATEGORY[key].name}
                  </Select.Option>
                ))}
              </Select>
            </TextField>
          )}
        </FieldRegister>
      </div>
      <div className="input-project__block">
      <FieldRegister
          name="retryTime"
          onChange={onChangeRetryTime}
          value={stateInfo.retryTime}
          disabled={isPageApprove || permissionDisabled}
          depend={stateInfo.timeout}
          validate={validateRetryTimeAndTimeout}
        >
          {({ onBlur, onChange, value, error, disabled }) => (
            <TextField label="Retry time (ms)" helperText={error}>
              <InputNumber
                min={1000}
                max={300000}
                className="input-project__timeout"
                type="number"
                size="large"
                placeholder="Enter Retry time"
                onChange={onChange}
                value={value}
                disabled={disabled}
                onBlur={onBlur}
              />
            </TextField>
          )}
        </FieldRegister>
        <FieldRegister
          name="timeout"
          onChange={onChangeTimeout}
          value={stateInfo.timeout}
          disabled={isPageApprove || permissionDisabled}
          validate={validateRequired('Timeout')}
        >
          {({ onBlur, onChange, value, error, disabled }) => (
            <TextField label="Timeout (ms)" required helperText={error}>
              <InputNumber
                min={1000}
                max={300000}
                className="input-project__timeout"
                type="number"
                size="large"
                placeholder="Enter Timeout"
                onChange={onChange}
                value={value}
                disabled={disabled}
                onBlur={onBlur}
              />
            </TextField>
          )}
        </FieldRegister>
        <FieldRegister
          name="accessLevel"
          value={stateInfo.accessLevel}
          onChange={onChangeAccessLevel}
          validate={validateRequired('Access level')}
          disabled={isPageApprove || permissionDisabled}
        >
          {({ onBlur, onChange, value, error, disabled }) => (
            <TextField label="Access Level" required helperText={error}>
              <Select
                placeholder="Select access level"
                style={{ width: '100%' }}
                size="large"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
              >
                <Select.Option value="PRIVATE">Private</Select.Option>
                <Select.Option value="PUBLIC">Public</Select.Option>
              </Select>
            </TextField>
          )}
        </FieldRegister>
      </div>
      <div className="input-project__block">
        <FieldRegister
          onChange={onChangeDesc}
          value={stateInfo.description}
          disabled={isPageApprove || permissionDisabled}
          name="shortDesc"
          validate={validateRequired('Short description')}
        >
          {({ onBlur, onChange, value, error, disabled }) => (
            <TextField label="Short Description" required helperText={error}>
              <Input.TextArea
                placeholder="Enter short description"
                rows={5}
                className="input-project__text-area"
                onChange={onChange}
                value={value}
                disabled={disabled}
                onBlur={onBlur}
              />
            </TextField>
          )}
        </FieldRegister>
      </div>
    </div>
  );
};

export default GeneralInformation;
